import React from 'react';

const EraserIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
    <path
      d="M19.63,7,13,.36a1.23,1.23,0,0,0-1.74,0l-7,7A1.25,1.25,0,0,0,4,8.21a1,1,0,0,0,0,.17L.46,11.9a1.55,1.55,0,0,0,0,2.2l5.43,5.44A1.55,1.55,0,0,0,7,20a1.53,1.53,0,0,0,1.1-.46L11.62,16l.18,0a1.23,1.23,0,0,0,.87-.36l7-7a1.22,1.22,0,0,0,0-1.75ZM7,18.46H7L1.54,13a0,0,0,0,1,0,0L4.88,9.64l5.48,5.47Zm4.78-4.08L5.62,8.2l6.54-6.54,6.18,6.18Z"
      style={{ fillRule: 'evenodd' }}
    />
  </svg>
);

export default EraserIcon;
